import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  image: {
    minWidth: '6.4rem',
    margin: 0,
  },
  placeholder: {
    backgroundColor: 'var(--ui-image-placeholder-background-color)',
    padding: '30%',
    objectFit: 'contain',
  },
}))

export default useStyles
